import { useEffect, useState } from "react";
import { MemberLayout } from "../../components/Layouts";
import { api, readUser, fmt } from "../../lib/api";

export default function Production() {
  const user = readUser();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/production").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const total = rows.reduce((s, r) => s + Number(r.amount || 0), 0);
  return (
    <MemberLayout user={user} active="Production">
      <div className="stat-row">
        <div className="stat-card">
          <span>Total production</span>
          <strong data-testid="production-total">${fmt(total)}</strong>
          <small>Across {rows.length} daily credits</small>
        </div>
      </div>
      <div className="table-panel">
        <div className="panel-heading"><div><span className="eyebrow">DAILY LEDGER</span><h3>Production history</h3></div></div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Date</th><th>Amount</th><th>Reference</th><th>Status</th></tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} data-testid={`production-row-${i}`}>
                  <td>{new Date(r.date).toLocaleString()}</td>
                  <td>${fmt(r.amount)}</td>
                  <td className="hash">{(r.reference || "").slice(0, 14)}…</td>
                  <td><span className="status confirmed">{r.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
          {!rows.length && <div className="table-empty">Production entries will appear here daily.</div>}
        </div>
      </div>
    </MemberLayout>
  );
}
